const _cloneDeep = require('lodash.clonedeep');

import { Status } from '../../shared/status.model';
import { availableGames, GAMES, defaultGameLeaderboardFilters } from '../../../mixins/games.commons';

const statistics = {};
const statisticsStatusMap = {};

const statsStatusMap = {
  getAllStats: new Status(),
  getGeneralStats: new Status(),
  getRankStats: new Status(),
  getActivityStats: new Status(),
};

function generateGameMap(game) {
  return {
    current: null,
    opponent: null,
    compare: { playerList: [] },
    leaderboard: {
      list: [],
      current: null,
      offset: 0,
      selectedFilters: defaultGameLeaderboardFilters[game],
    },
  };
}

const gameStatusMap = {
  current: { ...statsStatusMap },
  opponent: { ...statsStatusMap },
  compare: { searchPlayers: new Status() },
  leaderboard: {
    getLeaderboard: new Status(),
    getMoreLeaderboard: new Status(),
  },
};

availableGames.forEach(game => {
  statistics[game] = _cloneDeep(generateGameMap(game));
  statisticsStatusMap[game] = _cloneDeep(gameStatusMap);
});

export const profileStatusMap = {
  getConnectedGames: new Status(),
  general: {
    current: new Status(),
    opponent: new Status(),
  },
  statistics: {
    ...statisticsStatusMap,
  },
};

export const state = {
  currentBoomId: '',
  opponentBoomId: '',
  gameList: [],
  general: {
    current: null,
    opponent: null,
  },
  profileStatusMap: { ...profileStatusMap },
  statistics: {
    selectedGame: GAMES.FORTNITE,
    ...statistics,
  },
};
